import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AssetVersionThumbnailProps = ComponentProps<'div'>;

export const AssetVersionThumbnail = memo(({ className, ...restOfProps }: AssetVersionThumbnailProps) => {
  return (
    <div
      className={cn(
        'relative flex h-10 w-[72px] shrink-0 items-center justify-center overflow-hidden rounded-4 ads:bg-subtle bg-gray-1',
        className,
      )}
      data-testid="ASSET_VERSION_THUMBNAIL"
      {...restOfProps}
    />
  );
});

AssetVersionThumbnail.displayName = 'AssetVersionThumbnail';
